// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { RadioStyle } from "@insite/mobius/Radio";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { checkoutShippingFulfillmentMethodStyles } from "@pace/Overrides/Widgets/CheckoutShipping/CheckoutShippingFulfillmentMethodSelector";
import { xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

checkoutShippingFulfillmentMethodStyles.container = {
    css: css`
        column-gap: 32px;
        align-items: center;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            align-items: flex-start;
            row-gap: 12px;
        }
    `,
};
checkoutShippingFulfillmentMethodStyles.headingText = {
    variant: "h4",
    css: css`
        margin-bottom: 0;
    `,
};
checkoutShippingFulfillmentMethodStyles.radioGroup = {
    css: css`
        display: block;
        line-height: 1;
        > ${TypographyStyle} {
            margin: 0;
        }

        ${RadioStyle} {
            display: inline-block;
            margin-right: 32px;
            & + ${RadioStyle} {
                margin-top: 0;
            }
        }
    `,
};
